import { render } from "./EditProgram.vue?vue&type=template&id=6637ab2d&ts=true"
import script from "./EditProgram.vue?vue&type=script&lang=ts"
export * from "./EditProgram.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Vue\\donaska-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__